import { useEffect, useState } from "react";
import { Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { cloneDeep } from "lodash-es";
import EcologicalTabs from "@/components/EcologicalTabs";
import { UserChangeTabs } from "@/hooks";
import api from "@/api";

import dataJson from "@/../public/data.json";

import "./index.less";

const prefix = "resource";

function Resource() {
  const { stay_tuned, unfold, retract, resource, req_err } = dataJson;

  const [resourceData, setResourceData] = useState<any>(resource);
  const [key, setKey] = useState<string | null>("");
  const [params, setParams] = useSearchParams();

  const { current, tabsChange } = UserChangeTabs(prefix, resourceData, key);

  const dispatch = useDispatch();

  const unfoldRetractChange = (index: number, idx: number) => {
    const resourceDataCopy = cloneDeep(resourceData);
    const isUnfold = resourceDataCopy.list[index].list[idx].isUnfold;
    resourceDataCopy.list[index].list[idx].isUnfold = !isUnfold;

    // scrollTo(container, checkTabDom?.offsetTop - 100, 300, () => {
    //   dispatch({
    //     type: "setIsClickCauseScroll",
    //     payload: false,
    //   });
    // });
    setResourceData(resourceDataCopy);

    // dispatch({
    //   type: "setIsClickCauseScroll",
    //   payload: true,
    // });
  };

  const handleBtn = async (e: any) => {
    try {
      if (e.path) {
        const res: any = await api.defaultPrivate({ path: e.path });
        if (res.code === 200) {
          window.open(res.data, "_self");
        } else {
          window.message.error(res.msg || req_err);
        }
      } else {
        window.open(e.url, "_blank");
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  useEffect(() => {
    const key = params.get("key");
    setKey(key);
  }, []);

  return (
    <div className={prefix}>
      <div className={`${prefix}-banner`} style={{ backgroundImage: `url(${resourceData.banner_bg_img})` }}>
        <div className={`${prefix}-title`}>{resourceData.title}</div>
        <div className={`${prefix}-describe`}>
          <div>{resourceData.describe}</div>
        </div>
      </div>
      <EcologicalTabs current={current} list={resourceData.list} onChange={tabsChange} />
      <div className={`${prefix}-content`}>
        {resourceData.list.map((item: any, index: number) => {
          return (
            <div key={item.key} className={`${prefix}-module-wrap`} id={`${prefix}-module-${item.key}`}>
              <div className={`${prefix}-module`}>
                <div className={`${prefix}-module-title`}>{item.title}</div>
                {item.list?.length ? (
                  item.list.map((ele: any, idx: number) => {
                    return (
                      <div key={ele.key} className={`${prefix}-classify`}>
                        <div className={`${prefix}-classify-title`}>{ele.title}</div>
                        <div
                          className={`${prefix}-cards`}
                          style={{
                            height: ele.isUnfold
                              ? Math.ceil(ele.list.length / 2) * 322 + (Math.ceil(ele.list.length / 2) - 1) * 24
                              : 322,
                          }}
                        >
                          {ele.list.map((el: any) => {
                            return (
                              <div
                                className={`${prefix}-card`}
                                style={{ backgroundImage: `url(${resourceData.card_bg_img})` }}
                                key={el.key}
                              >
                                <div className={`${prefix}-card-title`}>{el.title}</div>
                                <div className={`${prefix}-card-describe`}>{el.describe}</div>
                                <div className={`${prefix}-card-btns`}>
                                  {el.btns?.length ? (
                                    <>
                                      {el.btns.map((e: any) => {
                                        return (
                                          <Button
                                            type="primary"
                                            ghost
                                            key={e.key}
                                            disabled={!e.url}
                                            onClick={() => handleBtn(e)}
                                            className={`${prefix}-card-btn`}
                                          >
                                            {e.label}
                                          </Button>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <Button type="link">{stay_tuned}</Button>
                                  )}
                                </div>
                                {el.taps?.length ? (
                                  <div className={`${prefix}-card-tags`}>
                                    <>
                                      {el.taps.map((e: any, i: number) => {
                                        return (
                                          <span key={i} className={`${prefix}-card-tag`}>
                                            {e}
                                          </span>
                                        );
                                      })}
                                    </>
                                  </div>
                                ) : null}
                                <img
                                  src={el.img}
                                  alt=""
                                  className={`${prefix}-card-img`}
                                  style={{ width: el.iconW, height: el.iconH }}
                                />
                              </div>
                            );
                          })}
                        </div>
                        {ele.list.length > 2 ? (
                          <div
                            className={`${prefix}-classify-unfoldRetract`}
                            onClick={() => {
                              unfoldRetractChange(index, idx);
                            }}
                          >
                            {ele.isUnfold ? retract : unfold}&nbsp;&nbsp;&nbsp;
                            <DownOutlined
                              className={`${prefix}-classify-unfoldRetract-icon ${ele.isUnfold ? "down" : "up"}`}
                            />
                          </div>
                        ) : null}
                      </div>
                    );
                  })
                ) : (
                  <div className={`${prefix}-module-empty`} style={{ backgroundImage: `url(${item.emptyImg})` }}>
                    {stay_tuned}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Resource;
